import script from "./WCOrderTypeCartOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCOrderTypeCartOption.vue?vue&type=script&setup=true&lang=ts"

import "./WCOrderTypeCartOption.vue?vue&type=style&index=0&id=49cc428b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cc428b"]])

export default __exports__